import { AutogenModelProspectAction, AutogenRowProspectAction } from "./autogen/AutogenModelProspectAction";

export class ModelProspectAction extends AutogenModelProspectAction<RowProspectAction> {
	constructor() {
		super(RowProspectAction);
	}
}

export class RowProspectAction extends AutogenRowProspectAction {
}